import React from 'react';
import { AppShell, Burger, Group, NavLink, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Inbox, FileText, Settings, LogOut } from 'lucide-react';

export default function AdminLayout() {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: 'Dashboard', icon: LayoutDashboard, link: '/admin' },
    { label: 'Requisições', icon: Inbox, link: '/admin/requests' },
    { label: 'Blog CMS', icon: FileText, link: '/admin/blog' },
    { label: 'Conteúdo', icon: Settings, link: '/admin/content' },
  ];

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header className="bg-navy border-b-0 flex items-center px-4">
        <Group h="100%" px="md">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" color="white" />
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-orange-500 rounded-md flex items-center justify-center">
              <span className="text-foreground font-bold text-lg">JW</span>
            </div>
            <span className="font-bold text-xl text-foreground">Backoffice</span>
          </div>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md" className="bg-slate-50 border-r border-slate-200">
        <div className="flex flex-col h-full">
          <div className="flex-1 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                active={location.pathname === item.link}
                label={<Text fw={500}>{item.label}</Text>}
                leftSection={<item.icon size={18} />}
                onClick={() => navigate(item.link)}
                className="rounded-md transition-colors data-[active=true]:bg-orange-100 data-[active=true]:text-orange-600"
              />
            ))}
          </div>
          
          <div className="pt-4 border-t border-slate-200">
            <NavLink
              label={<Text fw={500}>Sair</Text>}
              leftSection={<LogOut size={18} />}
              onClick={() => navigate('/')}
              className="rounded-md text-slate-600 hover:bg-slate-100 transition-colors"
            />
          </div>
        </div>
      </AppShell.Navbar>

      <AppShell.Main className="bg-slate-100/50 min-h-screen">
        <div className="max-w-6xl mx-auto py-4">
          <Outlet />
        </div>
      </AppShell.Main>
    </AppShell>
  );
}
